module.exports = __webpack_public_path__ + "img/PL08687.cd29f3e6.png";